export default {
    bindings: {
        order: '=',
        formTab: '=',
    },
    controller: 'orderRefundController',
    template: require('../views/order.refund.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/order.refund.component.js